import { ReactNode } from "react";
import { TriangleArrowDownIcon } from "@/shared/icons";

type Props = {
  children: ReactNode;
  back?: () => void;
};

export default function AuthTitle({ children, back }: Props) {
  const backComponent = back ? (
    <button
      type="button"
      onClick={back}
      className="aspect-square w-9.5 rounded-lg bg-gradient-red flex items-center justify-center [--bg-angle:45deg] disabled:[--bg-opacity:.4] absolute left-0"
    >
      <TriangleArrowDownIcon size={10} className="-rotate-90" />
    </button>
  ) : null;

  return (
    <div className="mb-7.5 font-bold flex h-9.5 shrink-0 justify-center text-[1.25rem] items-center relative">
      {backComponent}
      {children}
    </div>
  );
}
